export default __webpack_public_path__ + "static/media/poster.5e686720.jpg";